"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_const_AIO_Version2_Config_View_Group_Type = exports.SHu_const_AIO_Version2_Field_Type_Value_Source = exports.SHu_const_AIO_Version2_Field_Type_Input_Type = exports.SHu_const_AIO_Version2_Field_Type = exports.SHu_const_AIO_Version2_Field_Format = void 0;
exports.SHu_const_AIO_Version2_Field_Format = ["%", "$"];
exports.SHu_const_AIO_Version2_Field_Type = ["input", "value", "formula"];
exports.SHu_const_AIO_Version2_Field_Type_Input_Type = ["text", "number", "checkbox", "dropdown", "multi", "searchbox"];
exports.SHu_const_AIO_Version2_Field_Type_Value_Source = ["airtable_properties", "airtable_underwriting"];
exports.SHu_const_AIO_Version2_Config_View_Group_Type = [
    { label: "List", value: "1" },
    { label: "Grid", value: "2" },
    { label: "Groups", value: "3" },
];
